import React, { useCallback } from "react";
import * as H from "history";

import { RouteConfig } from "react-router-config";

import useRouter from "@/utils/useRouter";
import { getRemoteConfigValue } from "@/modules/app/useRemoteConfig";
import Redirect from "@/pages/App/Redirect";

import { defaultLocation } from "@/client/Root";

import loadable from "@loadable/component";

import compact from "lodash/compact";

const ModalDownloadApp = loadable(
  /* webpackPrefetch: true */ () => import("./ModalDownloadApp")
);
const ModalGdpr = loadable(() => import("./ModalGdpr"));
const ModalLogin = loadable(
  /* webpackPrefetch: true */ () => import("./Login/ModalLogin")
);
const ModalLoginEmail = loadable(
  /* webpackPrefetch: true */ () => import("./Login/ModalLoginEmail")
);
const ModalForgotPassword = loadable(
  /* webpackPrefetch: true */ () => import("./Login/ModalForgotPassword")
);
const ModalSignUp = loadable(
  /* webpackPrefetch: true */ () => import("./Login/ModalSignUp")
);

const useModalRoutes = (background?: H.Location) => {
  const { history } = useRouter();

  const isHistoryRoot = history.length <= 2;

  const isEmailJoinEnabled: boolean = getRemoteConfigValue(
    "email_join_enabled",
    false
  );

  const handleBackClick = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleClose = useCallback(() => {
    if (background) {
      history.replace(background);
    } else {
      history.replace(defaultLocation);
    }
  }, [history, background]);

  const routes: RouteConfig[] = compact([
    ...(getRemoteConfigValue("get_the_app_enabled", true)
      ? [
          {
            path: "/get-the-app",
            exact: true,
            render() {
              return <ModalDownloadApp onClose={handleClose} />;
            },
          },
        ]
      : []),
    ...(getRemoteConfigValue("login_enabled", true)
      ? [
          {
            path: "/me/edit/privacy",
            exact: true,
            render() {
              return <ModalGdpr onClose={handleClose} />;
            },
          },
          {
            path: "/login",
            exact: true,
            render() {
              return <ModalLogin onClose={handleClose} />;
            },
          },
          {
            path: "/join",
            exact: true,
            render() {
              return isEmailJoinEnabled ? (
                <ModalSignUp onClose={handleClose} />
              ) : (
                <Redirect to="/login" />
              );
            },
          },
          {
            path: "/login/email",
            exact: true,
            render() {
              return (
                <ModalLoginEmail
                  onClose={handleClose}
                  onBackClick={(!isHistoryRoot && handleBackClick) || undefined}
                />
              );
            },
          },
          {
            path: "/login/forgot-password",
            exact: true,
            render() {
              return (
                <ModalForgotPassword
                  onClose={handleClose}
                  onBackClick={(!isHistoryRoot && handleBackClick) || undefined}
                />
              );
            },
          },
        ]
      : []),
  ]);

  return routes;
};

export default useModalRoutes;
